function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLkGreen = function SvgLkGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      fill: "currentColor",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 28 28"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.001 10.464h4.333v2.158c.624-1.241 2.225-2.356 4.629-2.356 4.61 0 5.704 2.471 5.704 7.004v8.397H21v-7.364c0-2.582-.624-4.038-2.213-4.038-2.204 0-3.12 1.569-3.12 4.037v7.365h-4.666V10.464ZM2.999 25.468h4.666V10.266H2.999v15.202Zm5.335-20.16a2.953 2.953 0 0 1-.879 2.103 3.018 3.018 0 0 1-4.244.001 2.956 2.956 0 0 1-.877-2.104c0-.789.315-1.545.878-2.103a3.015 3.015 0 0 1 4.243 0 2.96 2.96 0 0 1 .879 2.103Z",
    style: {
      stroke: "CurrentColor",
      strokeWidth: 1
    }
  }));
};
export default SvgLkGreen;